import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';
import { normalizeKarpenterResponse } from 'utils/cluster';

const KARPENTER_INTENTS_QUERY_KEY = 'karpenter-intents';

export const getKarpenterMigrationIntentsQueryKey = (clusterId?: string) =>
  [KARPENTER_INTENTS_QUERY_KEY, clusterId] as const;

const getKarpenterMigrationIntentsQueryOptions = ({
  clusterId,
  enabled = true,
}: {
  clusterId?: string;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: getKarpenterMigrationIntentsQueryKey(clusterId),
    queryFn: async () => {
      const { data } = await apiClient.autoscaler.getKarpenterMigrationIntents({
        clusterId: clusterId!,
      });

      return normalizeKarpenterResponse(data);
    },
    enabled: !!clusterId && enabled,
  });

type KarpenterMigrationIntentsQueryArgs = {
  clusterId?: string;
  enabled?: boolean;
};

export const useKarpenterMigrationIntentsQuery = ({
  clusterId,
  enabled = true,
}: KarpenterMigrationIntentsQueryArgs) => {
  const { isLoading, data, error } = useQuery(
    getKarpenterMigrationIntentsQueryOptions({ clusterId, enabled })
  );
  return {
    isLoading,
    version: data?.version,
    objects: data?.objects,
    error,
  };
};
